import React from 'react';
import { motion } from 'framer-motion';
export function PricingSection() {
  return <section className="py-24 px-6 bg-gray-50" data-id="element-138">
      <div className="max-w-3xl mx-auto" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-140">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-900 mb-3" data-id="element-141">
            No pagas comisión. Tomas una mejor decisión.
          </h2>
          <p className="text-lg text-gray-500 mb-14" data-id="element-142">
            En una propiedad de alto valor, una comisión puede significar
            millones. Aquí pagas por estar bien representado, no por el precio
            de la propiedad.
          </p>

          <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden" data-id="element-143">
            <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-144">
              {/* Left — 15 UF */}
              <div className="p-10 md:p-12 flex flex-col items-center justify-center text-center border-b md:border-b-0 md:border-r border-gray-100" data-id="element-145">
                <span className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-3" data-id="element-146">
                  Inicio del proceso
                </span>
                <span className="text-4xl font-bold text-gray-900 tracking-tight mb-1" data-id="element-147">
                  15 UF
                </span>
                <span className="text-sm text-gray-400" data-id="element-148">
                  Para comenzar a trabajar juntos
                </span>
              </div>

              {/* Right — 135 UF */}
              <div className="p-10 md:p-12 flex flex-col items-center justify-center text-center bg-brand-50/30" data-id="element-149">
                <span className="inline-block text-xs font-bold text-brand-700 bg-brand-100 px-3 py-1 rounded-full uppercase tracking-wider mb-3" data-id="element-150">
                  Pago contra resultado
                </span>
                <span className="text-4xl font-bold text-brand-600 tracking-tight mb-1" data-id="element-151">
                  135 UF
                </span>
                <span className="text-sm text-gray-500 font-medium" data-id="element-152">
                  Solo si compras
                </span>
              </div>
            </div>

            <div className="border-t border-gray-100 py-3.5 px-6 text-center" data-id="element-153">
              <p className="text-sm text-gray-400" data-id="element-154">
                Pagas poco al inicio. El resto solo si avanzas.
              </p>
            </div>
          </div>

          <p className="text-lg text-gray-600 mt-10 max-w-2xl mx-auto leading-relaxed" data-id="element-155">
            Pagas por estar bien representado en una decisión enorme. Y aun así,
            es menos que el modelo tradicional.
          </p>

          <p className="text-sm text-gray-400 mt-3" data-id="element-156">
            Pagas poco al inicio. El resto solo si avanzas.
          </p>
        </motion.div>
      </div>
    </section>;
}